<template>
<div class="notification-widget-card d-flex justify-content-between align-items-center" role="button" @click="OpenNotifications">
    <div> {{ $t('Notification') }} </div>
    <div><span class="badge notification-widget-badge border">{{ data }}</span></div>
</div>
</template>

<script>
import 'dotenv/config'
import {DashboardGetProjectNotificationCount} from '@/actions/projectActions.js'
export default {
    name : 'NotificationWidget',
    props : ['projectInfo'],
    mounted : async function(){
        const self = this

        const response = await DashboardGetProjectNotificationCount(self.projectInfo._id)
        if(!response)
            return
        self.data = response.data
    },
    methods : {
        OpenNotifications(){
            const self = this
            window.location.href = self.dotNetUrl + '/project/notifications/' + self.projectInfo.projectOldId
            // this.$router.push({name : 'NotificationList', params : {id : this.projectInfo._id}})
        }
    },
    data(){
        return {
            dotNetUrl : process.env.VUE_APP_DOTNET_URL,
            data : 0
        }
    }
} 
</script>

<style scoped>
.notification-widget-card {
    min-height: 2.75rem;
    border-radius: 0;
    background: #ff671f;
    border: 1px solid #ff671f;
    color: #ffffff;
    cursor: pointer;
    margin: 0;
    padding: 0 1rem;
    transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}

.notification-widget-card:hover,
.notification-widget-card:focus {
    background: #e95614;
    border-color: #e95614;
    box-shadow: 0 0.5rem 1rem rgba(255, 103, 31, 0.18);
}

.notification-widget-card > div:first-child {
    font-weight: 600;
}

.notification-widget-badge {
    display: inline-flex;
    min-width: 2.5rem;
    height: 1.25rem;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    background: rgba(255, 245, 239, 0.18) !important;
    border-color: #fff5ef !important;
    color: #ffffff;
    font-size: 0.7rem;
    font-weight: 700;
    line-height: 1;
    padding: 0 0.55rem;
}
</style>
